import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";

// layouts

import Admin from "layouts/Admin.js";
import { Provider, useDispatch } from "react-redux";
import { store } from "store/store";
import Login from "views/Login";
import { setupAutoLogout } from "utils/setupAutoLogout";
import { logout } from "store/authSlice";

function AppWrapper() {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem("access");
    if (token) {
    setupAutoLogout(token, () => {
      dispatch(logout());
      window.location.href = "/login"; 
    });
  }
  }, [dispatch]);


 return (
    <BrowserRouter>
      <Switch>
        <Route path="/admin" component={Admin} />
        <Route path="/login" component={Login} />
        <Redirect
          exact
          from="/"
          to={localStorage.getItem("access") ? "/admin/dashboard" : "/login"}
        />
        {/* <Redirect exact from="/" to="/login" /> */}
        {/* <Redirect from="/" to="/login" /> */}
      </Switch>
    </BrowserRouter>
  );
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <AppWrapper />
  </Provider>
);


